import Calculation from "./calculation/calculation.component";
import { useGravelCalculationContext } from "./gravelCalculation";
import Result from "./result/result.component";

const GravelCalculatorComponent = () => {
    const { result, hasValidResult, width, length, thickness } =
        useGravelCalculationContext();

    return (
        <>
            <Calculation />
            {hasValidResult && (
                <Result
                    result={result}
                    mailParams={{
                        width,
                        gLength: length,
                        thickness
                    }}
                />
            )}
        </>
    );
};

export { GravelCalculatorComponent };
